import { render, staticRenderFns } from "./CorporateDirectory.vue?vue&type=template&id=ec823566"
import script from "./CorporateDirectory.vue?vue&type=script&lang=js"
export * from "./CorporateDirectory.vue?vue&type=script&lang=js"
import style0 from "./CorporateDirectory.vue?vue&type=style&index=0&id=ec823566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports